import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import "./BlogDetail.css";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import { GeneralFooter } from "../../../components";
import defaultBlogImage from "../../../assets/default-blog.png";
import dayjs from "dayjs";
import DOMPurify from "dompurify";
import { MooringMateHomeHeader } from "../../../components/HomeHeader/MooringMateHomeHeader";
import { getBlogById } from "../../../services/blog";

export const BlogDetail = () => {
  const baseUrl = process.env.REACT_APP_GENERAL_API_URL;
  const location = useLocation();
  const { id } = useParams();
  const [blog, setBlog] = useState(location?.state?.blog || null);
  const [loading, setLoading] = useState(!location?.state?.blog);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    // If no blog in state, fetch by ID from URL
    if (!blog && id) {
      const fetchBlog = async () => {
        const res = await getBlogById(id);
        if (res?.status === true && res?.data?.length > 0) {
          setBlog(res.data[0]);
        }
        setLoading(false);
      };
      fetchBlog();
    }
  }, [id, blog]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!blog) {
    return (
      <Box>
        <MooringMateHomeHeader />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <h2>Blog not found</h2>
        </Box>
        <GeneralFooter />
      </Box>
    );
  }

  return (
    <Box>
      <CssBaseline />
      <MooringMateHomeHeader />
      <Box component="main" className="top-section">
        <Box className="blog-detail">
          <Container maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item md={5}>
                <img
                  alt="blog image"
                  src={
                    blog?.imagePath
                      ? `${baseUrl}/${blog?.imagePath}`
                      : defaultBlogImage
                  }
                />
              </Grid>
              <Grid item md={7}>
                <Box className="blog-meta">
                  <div className="meta-content">
                    <h1 className="blog-title">{blog?.title}</h1>
                    <div className="metadata">
                      {dayjs(blog?.createdAt).format("YYYY-MM-DD  hh:mm A")}
                    </div>
                  </div>
                </Box>
              </Grid>
              <Grid item md={12}>
                <div className="blog-content"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(blog?.content),
                  }}
                ></div>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
      <GeneralFooter />
    </Box>
  );
};
